import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {Embedding, initialEmbeding} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {EmbeddingsListLoading} from '../components/loading/EmbeddingsListLoading'
import {createEmbeddings} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {PasswordMeterComponent} from '../../../../../../_metronic/assets/ts/components'
import {getAllRoles} from '../../../roles-list/core/_requests'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../../../../_metronic/common/rbac/Can'
import {useAuth} from '../../../../auth'
import {useCompanies} from '../../../../auth/core/Companies'
import {uploadProfile} from '../../../settings/core/_requests'

type Props = {
  isUserLoading: boolean
  embedding: Embedding
}

const EmbeddingFormModal: FC<Props> = ({embedding, isUserLoading}) => {
  const {setItemIdForUpdate, setpasswordUpdateCheck, passwordUpdateCheck} = useListView()
  const {refetch} = useQueryResponse()
  const [roles, setRoles] = useState<string[]>([])
  const auth: any = useAuth()
  const [isuploading, setuploading]: any = useState(false)
  const {defaultCompany} = useCompanies()
  const [selectedFile, setselectedFile]: any = useState(null)

  const inputStyle = {
    position: 'absolute' as 'absolute',
    opacity: 0,
    height: '100%',
    right: 0,
    top: 0,
  }

  const handleSubmit = async () => {
    setuploading(true);
    var logodata
    if (selectedFile) {
      logodata = await uploadProfile(selectedFile)
    }
    let data = {
      fileName: selectedFile.name,
      filePath: logodata?.data.url,
      embeddingGenerated: false,
      isActive: 'Not Active',
    }
    var uploadFile = await createEmbeddings(data, defaultCompany?.company_id ?? '');
    setuploading(false);
    window.location.reload(); 
  }

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  return (
    <>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}

          <div>
            <div className='fv-row mb-5 mt-5'>
              <label className='required fw-bold fs-6 mb-2'>Upload your context file</label>

              <div className='form-check form-check-custom form-check-solid form-check-success form-switch mt-5'>
                <div
                  className='form-check form-check-custom form-check-solid form-switch
                    mb-2'
                >
                  {!selectedFile && (
                    <>
                      <div className='me-5'>No File Selected</div>
                    </>
                  )}
                  {selectedFile && (
                    <>
                      <div className='me-5'>{selectedFile.name}</div>
                    </>
                  )}

                  <div className='btn btn-sm btn-primary me-2 position-relative overflow-hidden '>
                    Upload
                    <input
                      onChange={(e: any) => {
                        setselectedFile(e.target.files[0])
                        console.log(e.target.files[0])
                      }}
                      style={inputStyle}
                      type='file'
                      accept='.csv, .txt'
                      id='select-image'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
          >
            Discard
          </button>

          <button
            onClick={handleSubmit}
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={!selectedFile}
          >
            <span className='indicator-label'>Submit</span>
            {isuploading && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
    </>
  )
}

export {EmbeddingFormModal}
